import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
// client js begin
import 'flickity/css/flickity.css';
import env from '@tencent/vft-common/env';
import { debounce } from '@/util/helper';
// client js end

import VImage from '@/components/base/VImage/VImage.vue';
import vPreventAndroidScrollMixin from '@/mixin/directives/v-preventAndroidScroll';
import getUrlParam from '@/util/getUrlParam';
var tenvideoServiceModule = function tenvideoServiceModule() {
  return import('@tencent/vft-union-fetch/src/tenvideoService');
};
function isSame(newVal, oldVal) {
  var newList = newVal.vActList.slice(0, 10);
  var oldList = oldVal.vActList.slice(0, 10);
  for (var i = 0; i < newList.length; i++) {
    var newItem = newList[i];
    var oldItem = oldList[i];
    if (newItem.tPicList.mpList.pic_1080x404 !== oldItem.tPicList.mpList.pic_1080x404 || newItem.tActType.sH5Url !== oldItem.tActType.sH5Url) {
      return false;
    }
  }
  return true;
}
export default {
  name: 'Focus',
  //  serverCacheKey:props => props.data.vActList.slice(0, 10).map(item),
  mixins: [vPreventAndroidScrollMixin],
  props: {
    data: {
      required: true,
      type: Object
    },
    id: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      isReady: false,
      hasExpose: [],
      isAppTab: getUrlParam('ptag', this.$store.state.ctxInfo) === 'app_tab'
    };
  },
  computed: {
    list: function list() {
      return this.data.vActList.slice(0, 10);
    },
    reportParams: function reportParams() {
      return {
        f_module: '焦点图',
        f_module_id: this.id,
        eid: 'module'
      };
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.buildSlider();
    this.$watch('data', function (newVal, oldVal) {
      if (!isSame(newVal, oldVal)) {
        window.location.reload();
      } else if (env.isIphone) {}
    });

    // 兼容折叠屏主屏和副屏切换时轮播图未重置的问题
    // 此处的 500ms 取一个中间值，时间短的话重置不生效，时间长的话影响用户体验
    window.addEventListener('resize', debounce(function () {
      _this._flickity.resize();
    }, 500));
  },
  beforeDestroy: function beforeDestroy() {
    this._flickity && this._flickity.destroy();
  },
  components: {
    VImage: VImage
  },
  methods: {
    buildSlider: function buildSlider() {
      var _this2 = this;
      import('flickity').then(function (_ref) {
        var Flickity = _ref.default;
        _this2.isReady = true;
        _this2.$nextTick(function () {
          _this2._flickity = new Flickity(_this2.$refs.slider, {
            resize: true,
            wrapAround: true,
            prevNextButtons: false,
            autoPlay: 3000,
            pauseAutoPlayOnHover: false,
            pageDots: false,
            on: {
              change: function change(index) {
                var currentIndex = index;
                if (!_this2.hasExpose.includes(currentIndex)) {
                  _this2.$reportExpose(_this2.reportData.焦点图海报(_this2.list[currentIndex], currentIndex));
                  _this2.reportWeishi(_this2.list[currentIndex], 'expose');
                  _this2.hasExpose.push(currentIndex);
                }
                _this2._flickity.playPlayer();
              }
            }
          });
        });
      });
    },
    clickThisItem: function clickThisItem(clickIndex) {
      if (!this.list[clickIndex] && !this._flickity) return;
      var currentIndex = this.list[clickIndex] ? clickIndex : this._flickity.selectedIndex;
      this.openUrl(this.list[currentIndex].tActType.sH5Url);
      this.$reportClick(this.reportData.焦点图海报(this.list[currentIndex], currentIndex));
      this.reportWeishi(this.list[currentIndex], 'click');
    },
    reportWeishi: function () {
      var _reportWeishi = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(item, type) {
        var tenvideoService;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(item.sActID === '4837')) {
                  _context.next = 5;
                  break;
                }
                _context.next = 3;
                return tenvideoServiceModule();
              case 3:
                tenvideoService = _context.sent;
                if (tenvideoService.isAllTenvideo()) {
                  try {
                    tenvideoService.tenvideoCall('doPRMTAReport', {
                      eventName: type === 'click' ? 'pr_task_click' : 'pr_task_exposure',
                      reportKey: 'VIP_fuli_jdt',
                      reportParams: item.sReportParam
                    });
                  } catch (e) {}
                }
              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      function reportWeishi(_x, _x2) {
        return _reportWeishi.apply(this, arguments);
      }
      return reportWeishi;
    }()
  },
  ptag: 'jdt',
  reportData: {
    '焦点图海报': function 焦点图海报(item, index) {
      // 解构
      var title = item.sTitle,
        cubeId = item.sActID;
      return {
        f_resource: title + '海报',
        f_type: 5,
        f_cubeid: cubeId,
        eid: 'poster',
        item_idx: index,
        content_id: title,
        rtype: 'h5',
        poster_type: 'banner_card'
      };
    }
  }
};